<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="green" @click="addRow">新增项目</Button>
    </div>
    <div style="margin: 0 10px; overflow-x: auto;">
      <table class="social-table">
        <thead>
        <tr>
          <th style="width: 160px;">项目</th>
          <th>缴存基数</th>
          <th>公司比例(%)</th>
          <th>公司金额</th>
          <th>个人比例(%)</th>
          <th>个人金额</th>
          <th style="width: 100px;">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in rows" :key="row.key">
          <td>{{ row.name }}</td>
          <td align="right">{{ row.base | numFormat }}</td>
          <td align="center">{{ percentText(row.companyRate) }}</td>
          <td align="right">{{ row.companyAmount | numFormat }}</td>
          <td align="center">{{ percentText(row.personalRate) }}</td>
          <td align="right">{{ row.personalAmount | numFormat }}</td>
          <td class="text-center">
            <span class="actions" @click="edit(row)">编辑</span>
            <span class="actions" @click="remove(row)">删除</span>
          </td>
        </tr>
        <tr v-if="!rows.length">
          <td colspan="7" class="text-center">暂无项目</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td align="right"><b>合计</b></td>
          <td></td>
          <td></td>
          <td align="right"><b>{{ sum('companyAmount') | numFormat }}</b></td>
          <td></td>
          <td align="right"><b>{{ sum('personalAmount') | numFormat }}</b></td>
          <td></td>
        </tr>
        </tfoot>
      </table>
      <p class="gray-color" style="margin: 10px 0; font-size: 12px;">
        说明：比例按百分数填写（如 16 表示 16%），金额 = 缴存基数 × 比例。
      </p>
    </div>

    <!--编辑弹窗-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">五险一金项目</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="项目" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="缴存基数" prop="base">
          <NumberInput :min="0" v-model="form.base" @input="calcAmounts"></NumberInput>
        </FormItem>
        <FormItem label="公司比例(%)">
          <NumberInput :min="0" v-model="form.companyPercent" @input="calcAmounts"></NumberInput>
        </FormItem>
        <FormItem label="公司金额">
          <NumberInput :min="0" v-model="form.companyAmount" :disabled="true"></NumberInput>
        </FormItem>
        <FormItem label="个人比例(%)">
          <NumberInput :min="0" v-model="form.personalPercent" @input="calcAmounts"></NumberInput>
        </FormItem>
        <FormItem label="个人金额">
          <NumberInput :min="0" v-model="form.personalAmount" :disabled="true"></NumberInput>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const round2 = (val) => Math.round((Number(val) || 0) * 100) / 100;

//预置项目：养老/医疗/工伤/失业/公积金
const defaultNames = ['养老保险', '医疗保险', '工伤保险', '失业保险', '住房公积金'];

let keySeed = 0;

const decorate = (row) => Object.assign({}, row, {key: row.key || ('row_' + (++keySeed))});

export default {
  name: 'SocialSecurity',
  data() {
    return {
      rows: [],
      showForm: false,
      loading: false,
      form: {
        id: null,
        name: '',
        base: 0,
        companyPercent: 0,
        companyRate: 0,
        companyAmount: 0,
        personalPercent: 0,
        personalRate: 0,
        personalAmount: 0
      },
      validationRules: {
        required: ['name', 'base']
      }
    }
  },
  methods: {
    percentText(rate) {
      if (rate === null || rate === undefined || rate === '') {
        return '0.00';
      }
      return round2(Number(rate) * 100).toFixed(2);
    },
    sum(field) {
      return round2(this.rows.reduce((total, row) => total + (Number(row[field]) || 0), 0));
    },
    calcRow(row) {
      row.companyAmount = round2((Number(row.base) || 0) * (Number(row.companyRate) || 0));
      row.personalAmount = round2((Number(row.base) || 0) * (Number(row.personalRate) || 0));
      return row;
    },
    calcAmounts() {
      this.form.companyRate = round2((Number(this.form.companyPercent) || 0) / 100);
      this.form.personalRate = round2((Number(this.form.personalPercent) || 0) / 100);
      this.form.companyAmount = round2((Number(this.form.base) || 0) * this.form.companyRate);
      this.form.personalAmount = round2((Number(this.form.base) || 0) * this.form.personalRate);
    },
    defaults() {
      return defaultNames.map(name => this.calcRow(decorate({
        id: null,
        name,
        base: 0,
        companyRate: 0,
        companyAmount: 0,
        personalRate: 0,
        personalAmount: 0
      })));
    },
    loadList() {
      this.loading = true;
      this.$api.salary.social.list().then(({data}) => {
        let list = data || [];
        if (list.length) {
          this.rows = list.map(row => this.calcRow(decorate(row)));
        } else {
          //无数据时自动补 5 条默认 0 记录
          this.rows = this.defaults();
          this.initDefaults();
        }
      }).catch(() => {
        this.rows = this.defaults();
        this.initDefaults();
      }).finally(() => this.loading = false);
    },
    initDefaults() {
      Promise.all(this.rows.map(row => {
        return this.$api.salary.social.save({
          name: row.name,
          base: 0,
          companyRate: 0,
          companyAmount: 0,
          personalRate: 0,
          personalAmount: 0
        }).catch(() => null);
      })).then(() => {
        return this.$api.salary.social.list().then(({data}) => {
          if (data && data.length) {
            this.rows = data.map(row => this.calcRow(decorate(row)));
          }
        }).catch(() => null);
      });
    },
    addRow() {
      this.form = {
        id: null,
        name: '',
        base: 0,
        companyPercent: 0,
        companyRate: 0,
        companyAmount: 0,
        personalPercent: 0,
        personalRate: 0,
        personalAmount: 0
      };
      this.showForm = true;
    },
    edit(row) {
      this.form = {
        id: row.id,
        key: row.key,
        name: row.name,
        base: Number(row.base) || 0,
        companyPercent: round2((Number(row.companyRate) || 0) * 100),
        companyRate: Number(row.companyRate) || 0,
        companyAmount: Number(row.companyAmount) || 0,
        personalPercent: round2((Number(row.personalRate) || 0) * 100),
        personalRate: Number(row.personalRate) || 0,
        personalAmount: Number(row.personalAmount) || 0
      };
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      this.calcAmounts();
      let data = {
        id: this.form.id,
        name: this.form.name,
        base: Number(this.form.base) || 0,
        companyRate: this.form.companyRate,
        companyAmount: this.form.companyAmount,
        personalRate: this.form.personalRate,
        personalAmount: this.form.personalAmount
      };
      this.loading = true;
      this.$api.salary.social[data.id ? 'update' : 'save'](data).then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
      }).catch(() => {
        this.$Message.error('五险一金设置保存失败');
      }).finally(() => this.loading = false);
    },
    remove(row) {
      if (!row.id) {
        this.rows = this.rows.filter(item => item.key !== row.key);
        return;
      }
      this.$Confirm(`确认删除项目"${row.name}"？`).then(() => {
        this.$api.salary.social.delete(row.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('删除失败');
        });
      });
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.social-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    border: 1px solid #e2e2e2;
    padding: 8px 10px;
    font-size: 13px;
  }

  th {
    background: #f8f8f8;
    text-align: center;
  }
}
</style>
